import Dashboard from "./pages/Dashboard";

export default function AdminDashboard() {
  return <Dashboard />;
}